import React from 'react';
import { motion } from 'framer-motion';
import InfiniteScroll from 'react-infinite-scroll-component';
import DataCorrelationSkeletonContent from './DataCorrelationSkeletonContent';
import DataCorrelationItem from './DataCorrelationItem';

/** @type {*} */
const InfiniteScrollComponent = InfiniteScroll;

/**
 * @typedef {object} DataCorrelationGraphsListProps
 * @property {Array<*>} mergedReportData
 * @property {boolean} [isLoading]
 * @property {Object} [selectedClassificationMetric]
 * @property {Object} [selectedPracticeArea]
 * @property {() => void} fetchMoreData
 * @property {number} [totalGraphCount]
 */

/**
 * @param {DataCorrelationGraphsListProps} props
 */
const DataCorrelationGraphsList = props => {
  const {
    mergedReportData,
    isLoading,
    selectedClassificationMetric,
    selectedPracticeArea,
    fetchMoreData,
    totalGraphCount = 0
  } = props;

  if (!shouldDisplayGraphs(isLoading, mergedReportData)) {
    return (
      <motion.h4 initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        No correlation data available
      </motion.h4>
    );
  }

  return (
    <InfiniteScrollComponent
      dataLength={mergedReportData.length}
      hasMore={mergedReportData.length !== totalGraphCount}
      next={fetchMoreData}
      loader={<DataCorrelationSkeletonContent count={1} />}
      scrollThreshold={0.7}
      height={900}>
      {!mergedReportData.length ? (
        <DataCorrelationSkeletonContent count={2} />
      ) : (
        <>
          {mergedReportData.map(reportData => {
            const key = `${reportData.practiceGroupLevel}-${reportData.numberWithinLevel}-
            ${reportData.metricCalculationName}`;
            return (
              <DataCorrelationItem
                key={key}
                reportData={reportData}
                selectedClassificationMetric={selectedClassificationMetric}
                selectedPracticeArea={selectedPracticeArea}
              />
            );
          })}
          <div style={{ height: 20 }}></div>
        </>
      )}
    </InfiniteScrollComponent>
  );
};

const shouldDisplayGraphs = (loading, mergedReportData) => loading || mergedReportData.length;

export default DataCorrelationGraphsList;
